/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'at.markpub.facets.baseFormatting'

type $nsid = typeof $nsid

export { $nsid }

type Main = {
  $type?: 'at.markpub.facets.baseFormatting'
  index: ByteSlice
  features: (
    | l.$Typed<Strong>
    | l.$Typed<Header>
    | l.$Typed<Idify>
    | l.Unknown$TypedObject
  )[]
}

export type { Main }

const main = /*#__PURE__*/ l.typedObject<Main>(
  $nsid,
  'main',
  /*#__PURE__*/ l.object({
    index: /*#__PURE__*/ l.ref<ByteSlice>((() => byteSlice) as any),
    features: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<Strong>((() => strong) as any),
          /*#__PURE__*/ l.typedRef<Header>((() => header) as any),
          /*#__PURE__*/ l.typedRef<Idify>((() => idify) as any),
        ],
        false,
      ),
    ),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

/** Specifies the sub-string range a facet feature applies to. Start index is inclusive, end index is exclusive. Indices are zero-indexed, counting bytes of the UTF-8 encoded text. NOTE: some languages, like Javascript, use UTF-16 or Unicode codepoints for string slice indexing; in these languages, convert to byte arrays before working with facets. Byte slices can overlap. */
type ByteSlice = {
  $type?: 'at.markpub.facets.baseFormatting#byteSlice'
  byteStart: number
  byteEnd: number
}

export type { ByteSlice }

/** Specifies the sub-string range a facet feature applies to. Start index is inclusive, end index is exclusive. Indices are zero-indexed, counting bytes of the UTF-8 encoded text. NOTE: some languages, like Javascript, use UTF-16 or Unicode codepoints for string slice indexing; in these languages, convert to byte arrays before working with facets. Byte slices can overlap. */
const byteSlice = /*#__PURE__*/ l.typedObject<ByteSlice>(
  $nsid,
  'byteSlice',
  /*#__PURE__*/ l.object({
    byteStart: /*#__PURE__*/ l.integer({ minimum: 0 }),
    byteEnd: /*#__PURE__*/ l.integer({ minimum: 0 }),
  }),
)

export { byteSlice }

/** Facet feature for a `&lt;strong&gt;` HTML tag. For the byteSlice provided it should surround the underlying text. */
type Strong = { $type?: 'at.markpub.facets.baseFormatting#strong' }

export type { Strong }

/** Facet feature for a `&lt;strong&gt;` HTML tag. For the byteSlice provided it should surround the underlying text. */
const strong = /*#__PURE__*/ l.typedObject<Strong>(
  $nsid,
  'strong',
  /*#__PURE__*/ l.object({}),
)

export { strong }

/** Facet feature for a `&lt;h1&gt;` HTML tag. The integer is the level you want to use, as in h1, h2, h3, etc... For the byteSlice provided it should surround the underlying text. */
type Header = {
  $type?: 'at.markpub.facets.baseFormatting#header'
  level: number
}

export type { Header }

/** Facet feature for a `&lt;h1&gt;` HTML tag. The integer is the level you want to use, as in h1, h2, h3, etc... For the byteSlice provided it should surround the underlying text. */
const header = /*#__PURE__*/ l.typedObject<Header>(
  $nsid,
  'header',
  /*#__PURE__*/ l.object({
    level: /*#__PURE__*/ l.integer({ minimum: 1, maximum: 6 }),
  }),
)

export { header }

/** Facet feature instructs parsers to stringify the underlying text and include it as an id property on an HTML element. If this overlaps with an existing HTML tag generated by another facet, it is assumed that it will be applied to that tag. If there is no matching tag, use `&lt;span&gt;&lt;/span&gt;`. It is expected spaces are turned into hyphens. For example, a header facet with an idify feature might produce `&lt;h1 id="header-text"&gt;Header Text&lt;/h1&gt;`. */
type Idify = { $type?: 'at.markpub.facets.baseFormatting#idify' }

export type { Idify }

/** Facet feature instructs parsers to stringify the underlying text and include it as an id property on an HTML element. If this overlaps with an existing HTML tag generated by another facet, it is assumed that it will be applied to that tag. If there is no matching tag, use `&lt;span&gt;&lt;/span&gt;`. It is expected spaces are turned into hyphens. For example, a header facet with an idify feature might produce `&lt;h1 id="header-text"&gt;Header Text&lt;/h1&gt;`. */
const idify = /*#__PURE__*/ l.typedObject<Idify>(
  $nsid,
  'idify',
  /*#__PURE__*/ l.object({}),
)

export { idify }
